import React from 'react'


const Services = () => {
    return (
        <div>
            <section id='services'>
                <div className='container my-5 py-3 '>
                    <div className='row'>
                        <div className='col-12'>

                            <h3 className='fs-5 text-center mb-0 '>Our Service</h3>
                            <h1 className='display-6 mb-4 text-center'>Our <b>Awesome</b> Service</h1>
                            <hr className='w-25 mx-auto' />
                        </div>
                    </div>
                    <div className='row mt-5'>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center" >
                                    {/* <i className='fa fa-tooth fa-4x mb-4 text-primary logo'></i> */}
                                    <img src="https://www.oldsurgerydental.co.uk/nhs-dentist/wp-content/uploads/2017/04/dental-icon-orthodontics-001.png" alt="img" style={{ width: "100px", height: "100px" }} />

                                    {/* <i class="fad fa-address-book"></i> */}
                                    <h5 className="card-title mb-3 fs-3 ">Alignment Specialist</h5>
                                    <p className="card-text lead">Medicine in Dentistry (DMD) and has completed additional training in orthodontics and dentofacial orthopedics.</p>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center">
                                    {/* <i className='fa fa-mobile fa-4x mb-4 text-primary '></i> */}
                                    <img src="https://s3-us-west-2.amazonaws.com/issuewireassets/primg/37131/cosmetic-dentistry-icon1189718798.png" alt="img" style={{ width: "100px", height: "100px" }} />
                                    <h5 className="card-title mb-3 fs-3 ">Cosmetic Dentistry</h5>
                                    <p className="card-text lead">Cosmetic dental bonding can painlessly and quickly correct uneven or crooked teeth.</p>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center ">
                                    <img src="https://www.vidadentistry.co.uk/wp-content/uploads/2019/11/Greener-Dentistry.jpg" alt="img" style={{ width: "100px", height: "100px" }} />
                                    <h5 className="card-title mb-3 fs-3 ">Oral Hygiene Experts</h5>
                                    <p className="card-text lead"> It involves habits such as brushing twice a day and having regular dental checkups. brushing twice a day</p>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center">
                                    <img src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTfFHM7UK1n1Fm1nn3W1s5lN3XKg4iZGtCvP-1s9g2-2_AqSQD_70iOjwyQSx9A7vL3jso&usqp=CAU" alt="img" style={{ width: "100px", height: "100px" }} />
                                    <h5 className="card-title mb-3 fs-3 ">Root Canal Specialist</h5>
                                    <p className="card-text lead">Either your regular dentist can perform your tooth's work, or else a specialist.</p>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center">
                                    <img src="https://www.drhamidimplants.com/ezoojols/2020/12/dentist-icon-png-10.png" alt="img" style={{ width: "100px", height: "100px" }} />
                                    <h5 className="card-title mb-3 fs-3 ">Live Dental Advisory</h5>
                                    <p className="card-text lead">Ideal for advice and assessment of urgent dental matters or timely second opinions.</p>

                                </div>
                            </div>
                        </div>
                        <div className='col-md-4'>
                            <div className="card p-3 mb-3" >
                                <div className="card-body text-center">
                                <img src="https://pngimage.net/wp-content/uploads/2018/05/dental-png-3.png" alt="img" style={{width:"100px",height:"100px"}} />
                                    <h5 className="card-title mb-3 fs-3 ">Cavity Inspection</h5><br />
                                    <p className="card-text lead">Inspect the uvula and soft palate.</p>

                                </div>
                            </div>
                        </div>


                    </div>
                </div>
            </section>
        </div>
    )
}

export default Services